"use client";

import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function TimelineBanner() {
  const [currentYear, setCurrentYear] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  // Sample timeline data - you can replace this with API data
  const timelineData = [
    {
      year: "1986",
      title: "OUR JOURNEY",
      description: "",
      image: "",
    },
    {
      year: "1991",
      title: "OUR JOURNEY",
      description: "",
      image: "",
    },
    {
      year: "1998",
      title: "OUR JOURNEY",
      description: "",
      image: "",
    },
    {
      year: "2000",
      title: "OUR JOURNEY",
      description: ".",
      image: "",
    },
    {
      year: "2001",
      title: "OUR JOURNEY",
      description: "",
      image: "",
    },
  ];

  const years = [
    "1951",
    "1952",
    "1953",
    "1954",
    "1955",
    "1957",
    "1958",
    "1962",
    "1964",
    "1967",
    "1971",
    "1986",
    "1991",
    "1998",
    "2000",
    "2001",
  ];

  // Auto-slide functionality
  useEffect(() => {
    if (isPlaying) {
      const interval = setInterval(() => {
        setCurrentYear((prev) => (prev + 1) % timelineData.length);
      }, 4000);

      return () => clearInterval(interval);
    }
  }, [isPlaying]);

  const nextYear = () => {
    setCurrentYear((prev) => (prev + 1) % timelineData.length);
  };

  const prevYear = () => {
    setCurrentYear(
      (prev) => (prev - 1 + timelineData.length) % timelineData.length
    );
  };

  const goToYear = (index) => {
    setCurrentYear(index);
  };

  const currentData = timelineData[currentYear];

  return (
    <div className="relative w-full h-screen overflow-hidden bg-gray-900">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-all duration-1000 ease-in-out"
        style={{
          backgroundImage: `url(${currentData.image})`,
        }}
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-between p-8">
        {/* Main Content */}
        <div className="flex-1 flex items-center">
          <div className="max-w-2xl">
            <h1 className="text-6xl lg:text-8xl font-bold text-white mb-6 uppercase tracking-wider">
              {currentData.title}
            </h1>
            <div className="text-4xl lg:text-6xl font-bold text-white mb-8">
              {currentData.year}
            </div>
            <p className="text-lg lg:text-xl text-white/90 leading-relaxed max-w-3xl">
              {currentData.description}
            </p>
          </div>
        </div>

        {/* Timeline Navigation */}
        <div className="relative">
          {/* Timeline Years */}
          <div className="flex items-center justify-center space-x-8 overflow-x-auto pb-4">
            {years.map((year, index) => (
              <button
                key={year}
                onClick={() => {
                  const timelineIndex = timelineData.findIndex(
                    (item) => item.year === year
                  );
                  if (timelineIndex !== -1) {
                    goToYear(timelineIndex);
                  }
                }}
                className={`text-white text-sm font-medium px-3 py-2 rounded transition-all duration-300 ${
                  currentData.year === year
                    ? "bg-orange-600 text-white"
                    : "hover:bg-white/20"
                }`}
              >
                {year}
              </button>
            ))}
          </div>

          {/* Navigation Arrows */}
          <div className="flex justify-center space-x-4">
            <button
              onClick={prevYear}
              className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-all duration-300"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={nextYear}
              className="bg-white/20 hover:bg-white/30 text-white p-2 rounded-full transition-all duration-300"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>

      {/* Progress Indicator */}
      <div className="absolute bottom-0 left-0 w-full h-1 bg-white/20">
        <div
          className="h-full bg-orange-500 transition-all duration-100 ease-linear"
          style={{
            width: `${((currentYear + 1) / timelineData.length) * 100}%`,
          }}
        />
      </div>
    </div>
  );
}
